import React from 'react'
import getTransitionStyle from '../utils/getTransitionStyle'
import PropTypes from 'prop-types'

export default class PageAnimations extends React.Component {
  componentDidMount() {
    this.context.toggleOverflow(true)
    setTimeout(()=>{this.context.toggleOverflow(false)}, this.props.timeout * 2)
  }

  render(){
    const { timeout, delay, color, status } = this.props
    const overlayAppears = getTransitionStyle(status, timeout, timeout, 'overlayAppears')

    let lineTransitionLeft = getTransitionStyle(status, 500, 500, 'lineTransitionLeft')
    let lineTransitionRight = getTransitionStyle(status, 500, 500, 'lineTransitionRight')

    lineTransitionLeft = Object.assign({ backgroundColor: color }, lineTransitionLeft)
    lineTransitionRight = Object.assign({ backgroundColor: color }, lineTransitionRight)

    const exitOverlayAppears = getTransitionStyle(status, 800, 0, 'exitOverlayAppears')

    return (
      <div>
        <div
          className="page__overlay"
          style={overlayAppears}
        >
          <div
            className="transition__line--left"
            style={lineTransitionLeft}
          />
          <div
            className="transition__line--right"
            style={lineTransitionRight}
          />
        </div>

        <div
          className="page__exit-overlay"
          style={exitOverlayAppears}
        />
      </div>
    );
  }
}


PageAnimations.contextTypes = {
  toggleOverflow: PropTypes.func
};



// WEBPACK FOOTER //
// ./src/components/PageAnimations.js